import { render, staticRenderFns } from "./SuperUserIndex.vue?vue&type=template&id=576f701c&scoped=true&"
import script from "./SuperUserIndex.vue?vue&type=script&lang=js&"
export * from "./SuperUserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f701c",
  null
  
)

export default component.exports